<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C16.411 21 20 17.411 20 13C20 9.64999 17.928 6.77899 15 5.58899V7.81199C15.9109 8.33791 16.6676 9.09405 17.1941 10.0046C17.7207 10.9152 17.9986 11.9482 18 13C18 16.309 15.309 19 12 19C8.691 19 6 16.309 6 13C6.00133 11.9481 6.2792 10.9151 6.80575 10.0045C7.3323 9.09396 8.08901 8.33783 9 7.81199V5.58899C6.072 6.77899 4 9.64999 4 13C4 17.411 7.589 21 12 21Z" :fill="color"/>
    <path d="M11 2H13V12H11V2Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#999DA6',
      required: false,
    }
  }
};
</script>
